(() => {
  if (customElements.get('cv-product-slider')) return;
  customElements.define('cv-product-slider', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      const track = this.querySelector('.cv-related__track');
      const buttons = [...this.closest('.cv-related').querySelectorAll('[data-direction]')];
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let frame;
      let destination;
      const cancel = () => {cancelAnimationFrame(frame); destination = undefined;};
      const update = () => {
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        buttons[0].disabled = track.scrollLeft <= 2;
        buttons[1].disabled = track.scrollLeft >= maximum - 2;
      };
      const move = direction => {
        const card = track.querySelector('.cv-related__card');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
        const start = track.scrollLeft;
        const maximum = Math.max(0,track.scrollWidth - track.clientWidth);
        const end = Math.min(maximum,Math.max(0,(destination ?? start) + direction * step));
        cancelAnimationFrame(frame);
        destination = end;
        if (reduced.matches) {track.scrollLeft = end; destination=undefined;update();return;}
        const started = performance.now();
        track.style.scrollSnapType = 'none';
        const tick = now => {
          const progress = Math.min(1,(now-started)/480);
          track.scrollLeft = start + (end-start)*(1-Math.pow(1-progress,3));
          update();
          if (progress < 1) frame = requestAnimationFrame(tick);
          else {track.style.scrollSnapType='';destination=undefined;}
        };
        frame = requestAnimationFrame(tick);
      };
      buttons.forEach(button => button.addEventListener('click',()=>move(Number(button.dataset.direction)),options));
      track.addEventListener('keydown',event=>{
        if(event.target !== track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        event.preventDefault();
        if(event.key==='Home'||event.key==='End'){cancel();track.style.scrollSnapType='';track.scrollLeft=event.key==='Home'?0:track.scrollWidth;update();}
        else move(event.key==='ArrowLeft'?-1:1);
      },options);
      const interrupt = () => {cancel();track.style.scrollSnapType='';};
      track.addEventListener('pointerdown',interrupt,options);
      track.addEventListener('wheel',interrupt,{...options,passive:true});
      track.addEventListener('scroll',update,{...options,passive:true});
      this.observer = new ResizeObserver(()=>{interrupt();update();});
      this.observer.observe(track);
      this.cleanup = cancel;
      update();
    }
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.cleanup?.();}
  });
})();
